import { Ref, RefObject, useEffect } from "react";

/**
 * @description use like below
 * import React, { useRef } from 'react'
 * const Wrap = () => {
 *   const ref = useRef()
 *   useClickOutside(ref, () => callback, isTrigger?:boolean)
 *   return <Element ref={ref} />
 * }
 */
function useClickOutside(
  className: string,
  callback,
  isTrigger = true,
  dep: any[]
): void;
function useClickOutside(
  ref: RefObject<any> | RefObject<any>[],
  callback,
  isTrigger = true,
  dep: any[]
): void;
export function useClickOutside(
  ref: string | RefObject<HTMLElement>,
  callback,
  isTrigger: boolean,
  dep = [] as any[]
) {
  useEffect(() => {
    if (isTrigger) {
      const handleClickOutside = (e) => {
        if (typeof ref === "string") {
          const el = document.querySelector(ref);
          if (el && !el.contains(e.target)) {
            callback(e);
          }
          return;
        }
        if (Array.isArray(ref)) {
          if (
            ref.every((r) => r && r.current && !r.current.contains(e.target))
          ) {
            callback(e);
          }
        } else {
          ref && ref.current && !ref.current.contains(e.target) && callback(e);
        }
        ref && ref.current && !ref.current.contains(e.target) && callback(e);
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isTrigger, ...dep]);
}
